var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'join-sign': _vm.isZdd,
  }},[_c(_vm.showComponent,{tag:"component",attrs:{"isPopup":_vm.isPopup,"isFormLogin":_vm.isFormLogin}}),_c('van-popup',{model:{value:(_vm.dialogShow),callback:function ($$v) {_vm.dialogShow=$$v},expression:"dialogShow"}},[_c('img',{staticClass:"bannerDialogImg",staticStyle:{"height":"80vh"},attrs:{"src":require("@/assets/imgs/banner_dialog.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }